import pluralize from "pluralize";

import { ReactivationBonusBanner } from "../../ReactivationBonus/ReactivationBonusBanner";

interface BonusEligibleShiftShoppingBannerProps {
  bonusAmountInDollars: number;
  requiredShiftCount: number;
  startDate: string;
  deadlineDate: string;
  onClick: () => void;
  onDismiss: () => void;
}

export function BonusEligibleShiftShoppingBanner(props: BonusEligibleShiftShoppingBannerProps) {
  const { bonusAmountInDollars, requiredShiftCount, startDate, deadlineDate, onClick, onDismiss } =
    props;

  const shiftText = `${requiredShiftCount} eligible ${pluralize("shift", requiredShiftCount)}`;

  return (
    <ReactivationBonusBanner
      bonusAmountInDollars={bonusAmountInDollars}
      requiredShiftCount={requiredShiftCount}
      startDate={startDate}
      deadlineDate={deadlineDate}
      title={`Earn $${bonusAmountInDollars} Bonus`}
      description={`Book and complete ${shiftText} between ${startDate} and ${deadlineDate}`}
      buttonLabel="View eligible shifts"
      onClick={onClick}
      onDismiss={onDismiss}
    />
  );
}
